import React from "react";
//components
import { Box } from "@material-ui/core";
import { FTLPictureUpload, FTLTextField } from "ftl-dashboards-ui-kit";
import { usePictureUpload } from "ftl-dashboards-core";
export const PersonalDataTab = ({ formik, pictureSetFlag, setPictureFile, }) => {
    const { hiddenFileInputRef, filesUploadHandler, filesDeleteHandler, filesSelectHandler, } = usePictureUpload({ formik, pictureSetFlag, setPictureFile });
    return (React.createElement(Box, { display: "flex", justifyContent: "space-between" },
        React.createElement(Box, { display: "grid", mt: 6, gridGap: "24px", width: "360px" },
            React.createElement(FTLTextField, { required: true, name: "lastName", label: "\u0424\u0430\u043C\u0438\u043B\u0438\u044F", value: formik.values.lastName, onChange: formik.handleChange, error: formik.errors.lastName &&
                    formik.submitCount > 0 &&
                    formik.touched.lastName
                    ? true
                    : false, onBlur: formik.handleBlur, fullWidth: true }),
            React.createElement(FTLTextField, { required: true, name: "firstName", label: "\u0418\u043C\u044F", value: formik.values.firstName, onChange: formik.handleChange, error: formik.errors.firstName &&
                    formik.submitCount > 0 &&
                    formik.touched.firstName
                    ? true
                    : false, onBlur: formik.handleBlur, fullWidth: true }),
            React.createElement(FTLTextField, { name: "secondName", label: "\u041E\u0442\u0447\u0435\u0441\u0442\u0432\u043E", value: formik.values.secondName, onChange: formik.handleChange, error: formik.errors.secondName &&
                    formik.submitCount > 0 &&
                    formik.touched.secondName
                    ? true
                    : false, onBlur: formik.handleBlur, fullWidth: true })),
        React.createElement(Box, { mt: 6 },
            React.createElement(FTLPictureUpload, { onError: () => formik.setFieldValue("profileImageUrl", ""), onFileSelect: filesSelectHandler, onDelete: filesDeleteHandler, onUpload: filesUploadHandler, inputRef: hiddenFileInputRef, imageUrl: formik.values.profileImageUrl }))));
};
export default PersonalDataTab;
//# sourceMappingURL=PersonalDataTab.js.map